export default {"src":"/_next/static/media/family.colour.a894f5d8.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};